export function extractLatLng(url: string) {
  try {
    // Split the URL into parts by "!" to get the segments
    const segments = url.split("!");

    // Latitude and longitude are in the segment starting with "3d" and "2d"
    const latSegment = segments.find((segment) => segment.startsWith("3d"));
    const lngSegment = segments.find((segment) => segment.startsWith("2d"));

    if (!latSegment || !lngSegment) {
      throw new Error("Latitude or longitude not found in the URL");
    }

    // Extract the values and convert them to floats
    const lat = parseFloat(latSegment.slice(2)); // Remove the "3d" prefix
    const lng = parseFloat(lngSegment.slice(2)); // Remove the "2d" prefix

    return { lat, lng };
  } catch (error) {
    console.error("Error extracting lat/lng:", error);
    return null;
  }
}
